// removed by extract-text-webpack-plugin
module.exports = {"navbar":"_2ADPvmzR6oqCZgdvCJDn3u","top":"_2NVe397lKPAf62s7Kywjeq","hamburger":"_3cGfae3PDGDGFG80_L9vrK","title":"_1HH_CnAlOe9im4FRUFWozF","account":"tYAq4ou27eFOyVx17Hnda","signin-link":"_1Vf1GxuvtWP23k2y7jqK7F","cart":"_1xTKI3Sva2q1NwFrlKdUzs","num-in-cart":"_1dijyKJHKxwwta7I5Ms26h","bottom":"_2TV8zxy1leaPN_Km5WED1_","open":"_1zcufGVqSIS2CptFZc0T0m","item-link":"_3HsfsvYNQuV5duIdKx3mBM","item":"_2YFdiHV8-TfeVEX5jSmGtO","mobile-menu-meta":"_39RxNIx6mkuYlGEHWtWd_8","mobile-menu-account":"Z78AP9o2PzVFMnQKCxz68"};


//////////////////
// WEBPACK FOOTER
// ./src/features/Nav/nav.module.styl
// module id = 247
// module chunks = 79611799117203 210842664985301